import Vue from 'vue'
import App from './index.vue'
import router from './router'
import store from './store'
import { installErrorHandler } from './utils/errorHandler'

Vue.config.productionTip = false

installErrorHandler(Vue, store)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
